import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';
import { LayoutService } from '../services/layout.service';
import { NotificationService } from 'notification';
import { AuthService } from '../services/auth.service';
import { ApplicationService } from '../../features/application.service';
import { ConnectService } from './language-service';

export interface language {
  name: string
  language: string
}

@Component({
  selector: 'app-global-layout',
  templateUrl: './global-layout.component.html',
  styleUrls: ['./global-layout.component.scss']
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  title = 'Dev';
  modechk=''
  isExpand:boolean;
  isRightNavExpand:boolean;
  isProfile=false;
  curLang:string;
  addLangs:language[];
  isApp=false;
  countMsg:number=0;
  timeExecute:number=1;
  interval:any;
  isAlert=false;
  isSearch=false;
  isLang=false;
  isHelp=false;
  val=false;
  key:string;
  startedSubscription : Subscription;
  newAlertSubscription : Subscription;
  subscription:Subscription;
  changedLanguage:string='';
  constructor(
    private connectService: ConnectService, 
    private dataService:LayoutService,
    private notifyService:NotificationService,
    private authService: AuthService,
    private appSer:ApplicationService ){}
  handleChange(cnt:any){
    console.log("Handle change..", cnt.key)
    if(cnt.key =='profile' && cnt.val==true){
      this.isProfile = cnt.val;
      this.key = cnt.key;
    }
    if(cnt.key =='app'  && cnt.val==true ){
      this.isApp = cnt.val;
      this.key = cnt.key;
    }
    if(cnt.key =='alert'  && cnt.val==true){
      this.isAlert = cnt.val;
      this.key = cnt.key;
    }
    if(cnt.key =='search'  && cnt.val==true){
      this.isSearch = cnt.val;
      this.key = cnt.key;
    }
    if(cnt.key =='language'  && cnt.val==true){
      this.isLang = cnt.val;
      this.key = cnt.key;
    }
    if(cnt.key =='help'  && cnt.val==true){
      this.isHelp = cnt.val;
      this.key = cnt.key;
    }
  }
  ngOnInit() {

    this.notifyService.apiUrlSoc = environment.PLATFORM_AUTH_PH;
    this.notifyService.appProfile = this.authService.getUserToken();
    this.notifyService.apiUrl = environment.PLATFORM_AUTH;
    this.notifyUser();

    this.addLangs = [{ name: 'English', language: 'en' }];
    this.dataService.currentExpantValue.subscribe(data => {
      this.isExpand = data;
      if(window.innerWidth < 767 && this.isExpand) {
        this.modechk = 'overlay';
      }else{
        this.modechk = 'side';
      }
    })

    this.dataService.currentRightNavValue.subscribe(data=>
      {
        this.isRightNavExpand = data;
      })
  }
  sendLanguage(value){
    this.connectService.toggle(value);
    this.changedLanguage = value;
  }
 ngOnDestroy(){
   if(this.startedSubscription)
  this.startedSubscription.unsubscribe();
  if(this.newAlertSubscription)
  this.newAlertSubscription.unsubscribe();
  if(this.subscription)
  this.subscription.unsubscribe();
 }
  notifyUser(){
   this.subscription =  this.appSer.getTriggerMsg$.subscribe(data => {
      if(data){
        this.notifyService.getNotification(this.authService.getUserToken(), localStorage.getItem('countryVal')).subscribe(data1 =>{
          if(data1[0].messageResponses.length >= 0){
            this.notifyService.notificationCount.next(data1[0].messageResponses.length);
          }
        })
      }
    })
    this.notifyService.InitiateHubConnection(this.authService.getAccessToken());
    //this.notifyService.StartHubConnection();
    //this.notifyService.InitiateHubEvents();
    
      this.startedSubscription = this.notifyService.getStarted.asObservable().subscribe((res)=>{
      //console.log(res);
        setTimeout(()=> {
        this.notifyService.signInHandshake().subscribe({
          next: (res: any) => {
            this.newAlertSubscription = this.notifyService.getNewAlert.asObservable().subscribe(dataa => {
              //console.log(dataa);
              if(Object.keys(dataa).length){
                let msgData = JSON.parse(dataa);
                this.notifyService.notificationCount.next(msgData.Count);
                // let messageIds = msgData.filter(elem => elem.IsSent == false).map(element => element.MessageId);
                // let formData = {
                //   messageIds:messageIds,
                //   userId:""
                // }
                // if(messageIds.length > 0){
                //   this.notifyService.updateSendNotifyData(formData).subscribe(data =>{
                //   })
                // }
              } else if(this.countMsg == 0) {
                //this.notifyService.StartHubConnection();
                //this.notifyService.InitiateHubConnection(this.authService.getAccessToken());
                this.notifyService.getNotification(this.authService.getUserToken(), localStorage.getItem('countryVal')).subscribe(data1 =>{
                  if(data1[0].messageResponses.length >= 0){
                    this.countMsg = -1;
                    //this.notifyService.InitiateHubConnection(this.authService.getAccessToken());
                    this.notifyService.notificationCount.next(data1[0].messageResponses.length);
                  }
                })
              } else{
                //Disabled
                // this.timeExecute+=1;
                // if(this.timeExecute <6)
                // this.notifyService.InitiateHubConnection(this.authService.getAccessToken());
              }
            })
          },
          error: err => { },
          complete: () => {}
        });
      },1000);
    })
  }


  getLanguage(lang){
    this.curLang = lang;
    localStorage.setItem('Lang', lang)
  }
}
